import { ChangeDetectionStrategy, Component, InputSignal, Signal, computed, input } from '@angular/core';

import { AvatarComponent } from '@core/ui';
import { Profile } from '@mp/auth/profile/domain';
import { UserType } from '@mpk/shared/domain';
import { UserImagePipe } from '@mpk/shared/util';

@Component({
  selector: 'mpauth-profile-display',
  templateUrl: './profile-display.component.html',
  styleUrl: './profile-display.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'class()',
  },
  imports: [AvatarComponent, UserImagePipe],
})
export class ProfileDisplayComponent {
  private readonly componentCssClass: string = 'mpauth-profile-display';

  /**
   * The size of the component.
   */
  readonly size: InputSignal<'small' | 'large'> = input<'small' | 'large'>('large');

  /**
   * The profile to display.
   */
  readonly profile: InputSignal<Profile | null | undefined> = input<Profile | null>();

  protected readonly class: Signal<string> = computed(
    () => `${this.componentCssClass} ${this.componentCssClass}--${this.size()}`,
  );

  protected readonly UserType: typeof UserType = UserType;
}
